// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-textarea-wrapper label {
  font-size: 16px;
  color: #595C5F;
}
.request-textarea-wrapper textarea {
  appearance: none;
  border: 1px solid #ddd;
  border-radius: 2px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
  padding: 2px 4px;
  resize: none;
}
.request-textarea-wrapper textarea::placeholder {
  color: #aeaeae;
}
.request-textarea-wrapper textarea:focus-visible {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/TasksStatus/TasksStatus.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,cAAA;AAAR;AAGI;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AADR;AAGQ;EACI,cAAA;AADZ;AAIQ;EACI,aAAA;AAFZ","sourcesContent":[".request-textarea-wrapper{\n    label {\n        font-size: 16px;\n        color: #595C5F;\n    }\n\n    textarea {\n        appearance: none;\n        border: 1px solid #ddd;\n        border-radius: 2px;\n        font-size: 16px;\n        font-weight: 400;\n        color: #000;\n        padding: 2px 4px;\n        resize: none;\n\n        &::placeholder {\n            color: #aeaeae;\n        }\n\n        &:focus-visible{\n            outline: none;;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
